import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import styles from './LoginPage.module.css';

export function ForgotPasswordPage() {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [tenantSlug, setTenantSlug] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const trimmedEmail = email.trim().toLowerCase();
    const trimmedSlug = tenantSlug.trim().toLowerCase();

    try {
      const res = await fetch('/api/v1/auth/forgot-password', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Tenant-Slug': trimmedSlug,
        },
        body: JSON.stringify({ email: trimmedEmail }),
      });

      if (!res.ok) {
        const errBody = await res.json().catch(() => null);
        console.error('[forgot-password] request failed:', res.status, errBody);
        throw new Error(errBody?.detail || 'Request failed');
      }

      setSent(true);
    } catch (err) {
      console.error('[forgot-password] submit error:', err);
      setError(t('common:forgotPasswordError', 'Could not send reset email. Check the organization slug and try again.'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.page}>
      <form className={styles.form} onSubmit={handleSubmit} autoComplete="off">
        <h1 className={styles.title}>QENQ</h1>
        <p className={styles.subtitle}>
          {t('common:forgotPasswordTitle', 'Reset your password')}
        </p>

        {sent ? (
          <>
            <div className={styles.successMessage}>
              {t('common:forgotPasswordSent', 'If the email exists, a reset link has been sent. Check your inbox.')}
            </div>
            <Link to="/login" className={styles.linkButton}>
              {t('common:backToLogin', 'Back to login')}
            </Link>
          </>
        ) : (
          <>
            {error && <div className={styles.error}>{error}</div>}

            <div className={styles.field}>
              <label>{t('common:tenant', 'Organization')}</label>
              <input
                type="text"
                value={tenantSlug}
                onChange={(e) => setTenantSlug(e.target.value)}
                placeholder="your-organization"
                required
                autoComplete="off"
              />
            </div>

            <div className={styles.field}>
              <label>{t('common:email', 'Email')}</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="user@example.com"
                required
                autoComplete="off"
              />
            </div>

            <button type="submit" className={styles.submitBtn} disabled={loading}>
              {loading ? '...' : t('common:forgotPasswordSubmit', 'Send reset link')}
            </button>

            <Link to="/login" className={styles.linkButton}>
              {t('common:backToLogin', 'Back to login')}
            </Link>
          </>
        )}
      </form>
    </div>
  );
}
